import { IADICategory } from '../../api/adiCategories/adiCategories';

enum VideoType {
  BUSINESS = 'business',
  PERSONAL = 'personal',
}

enum PersonalVideoPurpose {
  EVENT = 'event',
  ANNOUNCEMENT = 'announcement',
  MEMORIES = 'memories',
  TRAVELS = 'travels',
  HIGHLIGHTS = 'highlights',
  OTHER = 'other',
}

interface IBaseVideoInfo {
  videoType: VideoType;
}

interface IBusinessVideoInfo {
  businessName: string;
  businessCategory: IADICategory;
}

interface IPersonalVideoInfo {
  videoPurpose: string;
  personalCategory: IADICategory;
}

interface IVideoInfoState
  extends Partial<IBaseVideoInfo>,
    Partial<IBusinessVideoInfo>,
    Partial<IPersonalVideoInfo> {}

export { VideoType, PersonalVideoPurpose };
export type { IVideoInfoState };
